import { gql } from '@apollo/client'

const UNQUOTED_RFQ_COUNT = gql`
  query UnquotedRfqsCount($filters: [[String]]) {
    unquotedRfqsCount(filters: $filters) {
      count
    }
  }
`

export default UNQUOTED_RFQ_COUNT
